module.exports = __webpack_public_path__ + "img/collection-weddingRingsRosegold.7923626.jpg";